export { templateStore as store } from './reducers'
export TemplateDetailsContainer from './containers/Details'

export TableDialog from './components/TableDialog'
